const paymentMethods = (paymentMethod) => {
    let label = '';

    switch (paymentMethod) {
        case 1:
            label = 'credit card';
            break;
        case 2:
            label = 'paypal';
            break;
        case 3:
            label = 'others/bank';
            break;
        case 4:
            label = 'Gcash';
            break;
        default:
            return;
    }

    return label;
}

const paymentSchedules = (paymentSchedule) => {
    let label = '';

    switch (paymentSchedule) {
        case 1:
            label = 'one-time';
            break;
        case 2:
            label = 'monthly';
            break;
        case 3:
            label = 'quarterly';
            break;
        case 4:
            label = 'semi-annually';
            break;
        case 5:
            label = 'annually';
            break;
        default:
            return;
    }

    return label;
}

const paymentStatus = (status) => {
    let label = '';

    switch (status) {
        case 1:
            label = 'not complete';
            break;
        case 2:
            label = 'complete';
            break;
        case 3:
            label = 'fail/canceled';
            break;
        default:
            return;
    }

    return label;
}

const childStatus = (status) => {
    let label = '';

    switch (status) {
        case 1:
            label = 'available';
            break;
        case 2:
            label = 'hidden';
            break;
        case 3:
            label = 'requested';
            break;
        case 4:
            label = 'sponsored';
            break;
        default:
            label = '..blank..';
    }

    return label;
}

const eventStatus = (status) => {
    let label = '';

    switch (status) {
        case 'active':
            label = 'Active';
            break;
        case 'draft':
            label = 'Draft';
            break;
        case 'completed':
            label = 'Completed';
            break;
        case 'postponed':
            label = 'Postponed';
            break;
        case 'cancelled':
            label = 'Cancelled';
            break;
        default:
            return;
    }

    return label;
}

const enums = {
    paymentMethods,
    paymentSchedules,
    paymentStatus,
    childStatus,
    eventStatus
}

export default enums